import { Container, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { string, type } from "superstruct";
import { ControlledTextField } from "../../Form/views/ControlledTextField";
import { useT } from "../../Translation/hooks/useT";
import { useWizardForm } from "../../Wizard/hooks/useWizardForm";
import { WizardFormProps } from "../../Wizard/types/WizardFormProps";
import { useTenderWizardStore } from "../hooks/useTenderWizardStore";

const FormValuesStruct = type({
  name: string(),
});

export const TenderWizardNameForm: FC<WizardFormProps> = (props) => {
  const t = useT();
  const { control, handleSubmit, onSubmit } = useWizardForm({
    store: useTenderWizardStore,
    formKey: props.formKey,
    FormValuesStruct,
    toFormValues: (tender) => ({
      name: tender?.name || "",
    }),
    toDoc: (formValues, tender) => ({
      name: formValues.name || undefined,
      isReviewed: {
        ...tender?.isReviewed,
        basicDetails: false,
      },
    }),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Container sx={{ pb: 3 }} maxWidth="sm">
        <Typography variant="h1" mb={4}>
          {t("TenderWizardNameForm_Title_Name")}
        </Typography>
        <Stack spacing={3}>
          <ControlledTextField
            required
            fullWidth
            name="name"
            autoComplete="off"
            label={t("TenderWizardNameForm_Label_Name")}
            control={control}
            autoFocus
          />
        </Stack>
      </Container>
    </form>
  );
};
